import EzUtils from "../../utils/EzUtils";
import StorageUtil from "../../utils/StorageUtil";

const URL_DATA = "urlData";

export default {

  clearUrlData() {
    StorageUtil.removeItem(URL_DATA);
  },

  setUrlData(urlData) {
    StorageUtil.setItem(URL_DATA, JSON.stringify(urlData));
  },

  getUrlData() {
    let urlData = EzUtils.convertToJSONObjectIfString(StorageUtil.getItem(URL_DATA));
    return urlData ? urlData : {};
  },

  setMerchantID(merchantID) {
    let urlData = this.getUrlData();
    urlData.merchantID = merchantID;
    this.setUrlData(urlData);
  },

  getMerchantID() {
    let urlData = this.getUrlData();
    return urlData.merchantID;
  },

  setMobile(mobile) {
    let urlData = this.getUrlData();
    urlData.mobile = mobile;
    this.setUrlData(urlData);
  },

  getMobile() {
    let urlData = this.getUrlData();
    return urlData.mobile;
  },

  setOTP(otp) {
    let urlData = this.getUrlData();
    urlData.otp = otp;
    this.setUrlData(urlData);
  },

  getOTP() {
    let urlData = this.getUrlData();
    return urlData.otp;
  },

  setLoanAccountNumber(loanAccountNumber) {
    let urlData = this.getUrlData();
    urlData.loanAccountNumber = loanAccountNumber;
    this.setUrlData(urlData);
  },

  getLoanAccountNumber() {
    let urlData = this.getUrlData();
    return urlData.loanAccountNumber;
  },

  setLeadId(leadId) {
    let urlData = this.getUrlData();
    urlData.leadId = leadId;
    this.setUrlData(urlData);
  },

  getLeadId() {
    let urlData = this.getUrlData();
    return EzUtils.isValidId(urlData.leadId) ? urlData.leadId : -1;
  },

  setEntity(entity) {
    let urlData = this.getUrlData();
    urlData.entity = entity;
    this.setUrlData(urlData);
  },

  getEntity() {
    let urlData = this.getUrlData();
    return urlData.entity;
  }
};

